var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.17,
    height: 11.85,
    viewBox: "0 0 7.17 11.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25,11.85A1.26,1.26,0,0,1,.37,9.71L4.16,5.92.37,2.13A1.24,1.24,0,0,1,2.13.37L6.81,5a1.27,1.27,0,0,1,0,1.77L2.13,11.48A1.25,1.25,0,0,1,1.25,11.85Z",
    fill: "#D163AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext3);
export default __webpack_public_path__ + "static/media/next-3.dbee91e89acbe1a008e8a6770bb0b17b.svg";
export { ForwardRef as ReactComponent };